import React from 'react';
import Box from '../Box/Box';
import { SxProp } from '../style/sxProp';
import Typography from '../Typography/Typography';

const ListItemLabel: React.FC<
  React.PropsWithChildren<{
    'aria-hidden'?: boolean;
    label: string;
    description?: string;
    sx?: SxProp;
  }>
> = ({ label, description, sx, 'aria-hidden': ariaHidden }) => (
  <Box
    aria-hidden={ariaHidden}
    sx={{
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      padding: '0 1 .5',
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ...(sx as any),
    }}
  >
    <Typography align="left" variant="body" color="default">
      {label}
    </Typography>
    {description && (
      <Typography align="left" variant="caption" color="light">
        {description}
      </Typography>
    )}
  </Box>
);

export default ListItemLabel;
